import { FC, ReactNode } from 'react'
import { defaultStylesCardWrapper } from '../styles'

interface CardWrapperProps {
  children: ReactNode
  style?: React.CSSProperties
}

const CardWrapper: FC<CardWrapperProps> = ({ children, style, ...rest }) => {
  return (
    <div
      style={{
        ...defaultStylesCardWrapper,
        ...style
      }}
      {...rest}
    >
      {children}
    </div>
  )
}

export default CardWrapper
